<template>
  <div id="principal">
    <header>
      <nav class="navbar navbar-expand-lg azulnav">

  <a class="navbar-brand text-white" href="#" style="max-height: 80px;" v-on:click="inicio()">
    <img src="https://muebles.uy/muebles-cdn/logodeplaka.svg" height="30" class="d-inline-block align-top" alt="DEPLAKA Cortes a su Medida"></a>
   <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarTogglerDemo01" aria-controls="navbarTogglerDemo01" aria-expanded="false" aria-label="Toggle navigation">
    
    <i class="fa fa-bars colorblanco" aria-hidden="true"></i>
  </button>

  <div class="collapse navbar-collapse" id="navbarTogglerDemo01">
    <ul v-if="islogin === true" class="navbar-nav mr-auto mt-2 mt-lg-0">
     <li v-if="this.$store.getters.accesodeplakcompleto === true" class="nav-item" data-toggle="collapse" data-target="#navbarTogglerDemo01">
        <a class="nav-link text-white" href="#" v-on:click="irabiblioteca()"> Biblioteca</a>
      </li>
      <li class="nav-item" data-toggle="collapse" data-target="#navbarTogglerDemo01">
        <a class="nav-link text-white" href="#" v-on:click="irapedidos()"> Pedidos</a>
      </li>
      <li class="nav-item" data-toggle="collapse" data-target="#navbarTogglerDemo01">
        <a class="nav-link text-white">{{ this.nombreusuario }}</a>
      </li>
    </ul>
    <ul v-else class="navbar-nav mr-auto mt-2 mt-lg-0">
      <li class="nav-item" data-toggle="collapse" data-target="#navbarTogglerDemo01">
        <a class="nav-link text-white" v-on:click="iniciarsesion()">Iniciar Sesion</a>
      </li>
    </ul>

    
  </div>
</nav>
    </header>
    <main>
   <router-view></router-view>
   
      
      
    </main>
  </div>

</template>
<script>

export default {
  name: 'principal',
  components: { },
  data: function () {
    return {
    }
  },
  methods: {
    iniciarsesion () {
      this.$router.push('/login')
    },
    inicio () {
      this.$router.push('/')
    },
    irapedidos () {
      this.$router.push('/pedidos')
    },
    irabiblioteca () {
      this.$router.push('/biblioteca')
    }
  },
  computed: {
    islogin: function () {
      return this.$store.getters.islogin
    },
    iscarpintero: function () {
      return this.$store.getters.escarpintero
    },
    nombreusuario: function () {
      return this.$store.getters.nombreusuario
    }
  }
}
</script>

<style>
body {
  margin: 0;
}

#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

main {
  text-align: center;
  margin-top: 40px;
}

header {
  margin: 0;
  height: 56px;
  padding: 0 16px 0 24px;
  background-color: #35495E;
  color: #ffffff;
}

header span {
  display: block;
  position: relative;
  font-size: 20px;
  line-height: 1;
  letter-spacing: .02em;
  font-weight: 400;
  box-sizing: border-box;
  padding-top: 16px;
}
.logodeplaka {
  display: inline; margin-top: 5px; color: #fff; font-size: 4em; font-family: 'hunter_squaredregular';
}
.azulnav{
      background-color: #35495E;
    color: #ffffff;
}
nav.azulnav{
  z-index: 999 !important;
}
.btn-primary{
  background-color: #0882d8 !important;
  border-color: #ffffff !important;
}
.btn-primary.disabled, .btn-primary:disabled {
    background-color: #cecece !important;
    color: #6b6b6b !important;
    border-color: #fbfbfb !important;
}
.colorblanco{
  color: #fff;
}
.btn-info {
    color: #fff;
    background-color: #126fde;
    border-color: #91c6f7;
}
.btn-outline-info {
    color: #126fde;
    background-color: transparent;
    background-image: none;
    border-color: #126fde;
}
.btn-outline-info:hover {
    color: #fff;
    background-color: #538fd6;
    border-color: #8fb0e4;
}
</style>



// WEBPACK FOOTER //
// src/App.vue